import { getInvestor } from "services/investor.routes";
import Loading from "components/Loading";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import queryString from "utils/queryString";
import InvestorTable from "./InvestorTable";
import { toast } from "react-toastify";

export default function Investor() {
    const [loading, setLoading] = useState(false);
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [investor, setInvestor] = useState([]);
    const [searchInfo, setSearchInfo] = useState({});
    const [trigger, setTrigger] = useState(null);

    const handleChange = (event) => {
        const { name, value } = event.target;
        setSearchInfo({ ...searchInfo, [name]: value });
    };
    useEffect(() => {
        setLoading(true);
        const query = {
            cursor: cursor === null ? null : cursor,
            phone_number: searchInfo?.phoneNumber ? searchInfo.phoneNumber : null,
            national_code: searchInfo?.nationalCode ? searchInfo.nationalCode : null,
            full_name: searchInfo?.fullName ? searchInfo.fullName : null,
        }
        getInvestor(queryString(query), trigger !== null, (isOk, data) => {
            setLoading(false);
            if (!isOk) {
                return toast.error(data.message)
            } else {
                if (page !== 0) {
                    setInvestor((prev) => ([...prev, ...data.data]));
                } else {
                    setInvestor(data.data);
                }
                setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                setHasMore(data.meta.next_cursor !== null);
            }
        })
    }, [page, trigger]);

    const onFilterClick = () => {
        setPage(0);
        setCursor('');
        setTrigger(Math.random());
    }
    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }
    return (
        <DashboardLayout>
            <Loading loading={loading} />
            <DashboardNavbar />
            <InfiniteScroll dataLength={investor.length} next={fetchMoreData} hasMore={hasMore}>
                <InvestorTable data={investor} filterInfo={searchInfo} handleFilterChange={handleChange} onFilterClick={onFilterClick} />
            </InfiniteScroll>
        </DashboardLayout>
    )
}